module.exports = __webpack_public_path__ + "media/src/images/icons/mobile-cc366ecdbe25054ef8bd00cb1c3e23d4.svg";